export default __webpack_public_path__ + "1c7050f7983a13683047aa21eefafb65.svg";